import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'ramda';

import styleFile from './SelectPayform.js';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import RichText from '@synergycms_core/components/generic/RichText';
import SelectField from '@synergycms_core/components/generic/Form/SelectField.jsx';
import { List, Map } from 'immutable';
import classnames from 'classnames/bind';
import { getPenalties, getPenaltyTimezone } from '../../../utils/penalties';
import { PROPERTY_MANAGEMENT_GROUP } from '../../../config/constants';
import { isIE, decodeBlackEmail,isAppleDevice } from '../../../utils';

const styles = (theme) => ({
  control: base => ({
    ...base,
    border: 'none',
    position: 'relative',
    boxShadow: '0 0 2px 0 rgba(0, 0, 0, 0.5)',
    borderRadius: 'unset',
    font: '300 13px Roboto, sans-serif',
    height: '40px',
    "@media (min-width: 901px)": {
      height: '50px'
    },
  }),
  indicatorSeparator: base => ({
    display: 'none'
  }),
  menu: base => {
    return {
      ...base,
      zIndex: '10',
      width: '100%',
      borderRadius: '0',
    };
  },
  dropdownIndicator: base => ({
    ...base,
    pointer: 'cursor',
    color: theme,
    '&:hover': {
      color: theme
    }
  }),
  indicatorsContainer: base => ({
      ...base,
      pointer: 'cursor',
      position: 'absolute',
      right: 0,
      top: 0,
      bottom: 0
  }),
  menuList: base => ({
    ...base,
    padding: 0,
  }),
  input: base => ({
    ...base,
    left: 0,
    top: 0,
    bottom: 0,
    right: 0,
    position: 'absolute'
  }),
});



const PayFormSingleValue = compose(
  withThemeJSS({ styleFile, displayName: 'SelectPayform' })
)(props => {
  const { classes } = props.theme.styles;

  let cx = classnames.bind(classes);

  return (
    <div {...props.innerProps} className={cx('row', 'test')}>
      <div className={props.cx(classes.title, { disabled: props.isFocused })}>
        <RichText ucFirst={true} innerStyle={['roboto13SoftGray', 'accesabilityGray']} text={'_%forma de pago%_'} translate={true} />
      </div>
      <RichText
        ucFirst={true}
        innerStyle={[
          'roboto16Black',
          classes.optionTitle,
          cx({ isFocused: props.isFocused, isSelected: props.isSelected })
        ]}
        text={props.data.get('name')}
        translate={true}
      />
    </div>
  );
});

const PayFormOption = compose(
  withThemeJSS({ styleFile, displayName: 'SelectPayform' })
)(props => {
  const { classes } = props.theme.styles;
  let cx = classnames.bind(classes);
  return (
    <div {...props.innerProps} className={cx('rowSelect', 'payFormOptions')}>
      <RichText
        ucFirst={true}
        innerStyle={['roboto16Black', cx({ isFocused: props.isFocused, isSelected: props.isSelected })]}
        text={props.data.get('name')}
        translate={true}
      />
    </div>
  );
});

const StaticPayForm = props => {
  const { payForms, classes, isBlacklisted } = props;
  return (
    payForms.size === 1 && (
      <div
        className={
          (payForms.size === 1 && ['htl', 'op'].includes(payForms.getIn([0, 'code']))) || isBlacklisted
            ? classes.hide
            : classes.staticPayForm
        }>
        <RichText ucFirst={true} innerStyle={classes.paymentMethod} text={'_%forma de pago%_'} translate={true} />
        <RichText
          ucFirst={true}
          innerStyle={['roboto16Black', classes.optionTitle]}
          text={payForms.getIn([0, 'name'])}
          translate={true}
        />
      </div>
    )
  );
};

class SelectPayform extends React.Component {
  static displayName = 'SelectPayform';

  render() {
    const { payForms, defaultValue, notRefundable, isBlacklisted, defaultOnlinePayment } = this.props.config;
    const { classes } = this.props.theme.styles;
    let defaultPayform = false;
    if(defaultValue) {
      defaultPayform = payForms.find(payForm => payForm.get('code') === defaultValue);
    } else if(!defaultValue && defaultOnlinePayment) {
      defaultPayform = payForms.find(payForm => payForm.get('code') === 'op');
    }

    return (
      <div className={classes.selectBox}>
        <div>
          <SelectField
            getOptionLabel={option => option.get('name')}
            getOptionValue={option => option.get('code')}
            defaultValue={defaultPayform || payForms.get(0)}
            model={'payForm'}
            placeholder={""}
            options={payForms}
            isSearchable={false}
            isClearable={false}
            components={{
              Option: PayFormOption,
              SingleValue: PayFormSingleValue
            }}
            styles={styles(this.props.theme.themeValues.mainColor)}
            innerStyle={(payForms.size === 1 || isBlacklisted) ? [classes.hide] : [classes.inputSelect]}
          />
        </div>
        <StaticPayForm payForms={payForms} notRefundable={notRefundable} classes={classes} />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {};
};

const mapStateToProps = (store, ownProps) => {
  const hotelId = store.getIn(['customer', 'current_hotel']);
  const reservation = store.getIn(['customer', 'reservation']);
  const onlinePayForm = Map({ code: 'op', name: 'pago online' });
  const corporatePayForms = store.getIn(['customer', 'corporate', 'pay_forms'], List());
  const hotelPayForm = Map({ code: 'htl', name: '_%pago en el hotel%_' });
  const payLinkPayForm = Map({ code: 'paylink', name: '_%pay link%_' });
  const managementGroupID = store.getIn(['hotels', hotelId, 'management_group_id']);
  const hotelCountry = store.getIn(['hotels', hotelId, 'country_iso_code']);
  const referer = store.getIn(['customer', 'params', 'url_params', 'referer_code'], false);
  const acceptPayLinks = store.getIn(['hotels', hotelId, 'affiliates_with_paylink'], List()).includes(referer);
  const chargebackUSA = store.getIn(['hotels', hotelId, 'chargeback_usa'], false);
  const penalties = getPenalties(reservation,store.getIn(['hotels', hotelId, 'management_group_id']) === PROPERTY_MANAGEMENT_GROUP,null,null, store.getIn(['hotels', hotelId, 'management_group_id']), getPenaltyTimezone(store.getIn(['hotels', hotelId])), chargebackUSA);
  const notRefundable = penalties[0].nr || penalties[0].flexible || false;
  const release = penalties[0].release || 0;
  const payPalPayForm = Map({ code: 'paypal', name: 'PayPal' });
  const amazonPayPayForm = Map({ code: 'amazon_pay', name: 'Amazon Pay' });
  const tpvEnabled = !(store.getIn(['hotels', hotelId, 'tpv_only_gift_voucher'], false)) ? store.getIn(['hotels', hotelId, 'tpv', 'name'], false) : false;
  const payPalEnabled = store.getIn(['hotels', hotelId, 'paypal', 'name'], false);
  let blacklistedEmails = store.getIn(['hotels', hotelId, 'blacklist_emails'], false);
  blacklistedEmails = blacklistedEmails && blacklistedEmails.map(emailB64 =>decodeBlackEmail(emailB64, hotelId));
  const amazonPayEnabled = store.getIn(['hotels', hotelId, 'amazon_pay', 'name'], false);
  const directPayment = store.getIn(['hotels', hotelId, 'payment_info', 'direct_payment'], true);
  const bizumPayForm = Map({ code: 'bizum', name: 'Bizum' });
  const applePayform = Map({ code: 'apple', name: 'ApplePay' });
  const bizumParam = tpvEnabled && (['EPG','Redsys'].includes(tpvEnabled)) &&  store.getIn(['hotels', hotelId, 'tpv','tpv_params']).find(p => p.get('code') === 'bizum_enabled', Map());
  const googlePayform = Map({ code: 'googlePay', name: 'GooglePay' });
  const appleParam = ['EPG', 'Redsys'].includes(tpvEnabled) &&  store.getIn(['hotels', hotelId, 'tpv','tpv_params']).find(p => p.get('code') === 'apple_pay', Map());
  const defaultOP = store.getIn(['hotels', hotelId, 'default_online_payment'], false);
  const googlePayParam = [
    'Stripe',
    'Redsys'
  ].includes(tpvEnabled) &&  store
    .getIn(['hotels', hotelId, 'tpv','tpv_params'])
    .find(p => p.get('code') === 'google_pay', Map());

  const keyConfigurationGooglePay = [
    'Stripe'
  ].includes(tpvEnabled)
    ?  store.getIn(['hotels', hotelId, 'tpv','tpv_params'])
      .find(p => p.get('code') === 'key_configuration_googlepay', Map())
    : null;

  const hasGooglePay = googlePayParam &&
      googlePayParam?.get('value') &&
      ['true', 'false'].includes(googlePayParam.get('value')) &&
      googlePayParam.get('value') === 'true'
    ? 'true'
    : null;

  const hasKeyConfig = keyConfigurationGooglePay ? keyConfigurationGooglePay.get('value') : null;

  let googlePayEnabled = 'false';

  if (tpvEnabled === 'Stripe') {

    googlePayEnabled = (hasGooglePay && hasKeyConfig) ? 'true' : 'false';
  } else if (tpvEnabled === 'Redsys') {

    googlePayEnabled = hasGooglePay ? 'true' : 'false';
  }



  const appleEnabled = appleParam ? appleParam.get('value', '') : '0';
  const bizumEnabled = bizumParam ? bizumParam.get('value', '') : '0';
  const reservationEmail = reservation.getIn(['customer','email'], false);

  let blacklistedEmail = false;

  const nemuruTpvParams = store.getIn(['hotels', hotelId, 'nemuru', 'tpv_params'], false);
  const nemuruEnabled = nemuruTpvParams
    ? nemuruTpvParams.some(param => param?.get('code') === 'agent_id' && param.get('value'))
    : false;
  const nemuruPayForm = Map({ code: 'bnpl', name: 'pago a plazos' });

  if(tpvEnabled && reservationEmail && blacklistedEmails && blacklistedEmails.includes(reservationEmail)) {
    blacklistedEmail = true;
  }
  let finalPayForms = List();
  
  const bookingDate = reservation.get('booking_date') //2025-07-01T11:22:55.286Z
  const checkin = reservation.get('checkin'); // 2025-07-02T00:00:00.000Z
  const daysDifference = Math.ceil((new Date(checkin) - new Date(bookingDate)) / (1000 * 60 * 60 * 24));

  if (ownProps.reservationPaid) {
    finalPayForms = finalPayForms.push(hotelPayForm);
  } else if (chargebackUSA && notRefundable && release >= daysDifference) {
    finalPayForms = finalPayForms.push(hotelPayForm);
  } else if(blacklistedEmail && tpvEnabled) {
    finalPayForms = finalPayForms.push(onlinePayForm);
  } else if(
    managementGroupID === PROPERTY_MANAGEMENT_GROUP &&
    tpvEnabled &&
    hotelCountry === 'AR' &&
    store.getIn(['customer', 'country', 'code'], 'AR') !== 'AR'
  ) {
    finalPayForms = finalPayForms.push(onlinePayForm);
  } else if(
    managementGroupID === PROPERTY_MANAGEMENT_GROUP &&
    hotelCountry === 'AR' &&
    store.getIn(['customer', 'country', 'code'], '') === 'AR'
  ) {
    finalPayForms = finalPayForms.push(hotelPayForm);
  } else {
    //Super xapu per controlar q l'hotel [293, SYN293, exe-vila-d'obidos] no tingui htl per defecte
    if (hotelId && hotelId.toString() !== '293') {
      finalPayForms = finalPayForms.push(hotelPayForm);
    }

    if (tpvEnabled && notRefundable && !(isIE() && tpvEnabled === 'EPG')) {
      finalPayForms = finalPayForms
        .delete(finalPayForms.findIndex(payForm => payForm.get('code') === 'htl'))
        .push(onlinePayForm);
    } else if (tpvEnabled && !(isIE() && tpvEnabled === 'EPG')) {
      finalPayForms = finalPayForms.push(onlinePayForm);
    }
    if (amazonPayEnabled) {
      finalPayForms = finalPayForms.push(amazonPayPayForm);
    }
    if (payPalEnabled) {
      finalPayForms = finalPayForms.push(payPalPayForm);
    }
    if(acceptPayLinks) {
      finalPayForms = finalPayForms.push(payLinkPayForm);
    }
    if(tpvEnabled && bizumEnabled === '1') {
      finalPayForms = finalPayForms.push(bizumPayForm);
    }
    if(tpvEnabled && appleEnabled === 'true' && isAppleDevice()) {
      finalPayForms = finalPayForms.push(applePayform);
    }

    if(tpvEnabled && googlePayEnabled === 'true' && !isAppleDevice()) {
      finalPayForms = finalPayForms.push(googlePayform);
    }

    finalPayForms = finalPayForms.concat(
      corporatePayForms.filter(payForm => payForm.get('code') !== 'htl' && payForm.get('code') !== 'op')
    );

    if (corporatePayForms.findIndex(payForm => payForm.get('code') === 'htlng') !== -1) {
      finalPayForms = finalPayForms.delete(finalPayForms.findIndex(payForm => payForm.get('code') === 'htl'));
    }

    if(!directPayment && finalPayForms.size > 1){
      let index = finalPayForms.findIndex(payForm => payForm.get('code') === 'htl');
      if(index !== -1){
        finalPayForms = finalPayForms.delete(index);
      }
    }
    
    if(nemuruEnabled) {
      finalPayForms = finalPayForms.push(nemuruPayForm);
    }
  }

  return {
    payForms: finalPayForms,
    notRefundable: notRefundable,
    blacklistedEmail : blacklistedEmail && tpvEnabled,
    defaultOnlinePayment : defaultOP && tpvEnabled
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  PropertyManager(['payForms', 'notRefundable', 'defaultValue', 'reservationPaid', 'blacklistedEmail', 'defaultOnlinePayment']),
  withThemeJSS({ styleFile, link: true })
)(SelectPayform);
